<div class="dwspay-payment-wrapper">
  <div id="dwspay-payment-element">
    <!-- Payment Element will be mounted here -->
  </div>
</div>
